import { Product } from '../../models/product';

export const getCategoryAndSubcategoriesLine = (
  product: Product,
  showCategory?: boolean
) => {
  const humanReadableSubcategories = product.subcategories?.map(
    s => product.category.subcategories?.find(e => e[0] === s)?.[1]
  );

  const humanReadableSubcategoriesInLine =
    humanReadableSubcategories?.join(', ');

  if (product.category.name && humanReadableSubcategoriesInLine) {
    if (showCategory) {
      return `${product.category.name}: ${humanReadableSubcategoriesInLine}`;
    } else {
      return humanReadableSubcategoriesInLine;
    }
  } else {
    return product.category.name;
  }
};

export function formatDistance(distanceKm: number) {
  if (distanceKm < 1000) {
    return Math.round(distanceKm); // round to nearest integer
  } else if (distanceKm < 10000) {
    return Math.round(Math.round(distanceKm * 10) / 10); // round to 1 decimal place
  } else {
    return Math.round(Math.round(distanceKm / 100) * 100); // round to nearest hundred
  }
}
